import styled from "styled-components";

export const FooterStyle = styled.footer`
  width: 100%;
  flex-shrink: 0;
`;
